import { put, takeLatest } from "redux-saga/effects";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "common/components/apiConfig";

export const actionTypes = {
  selectStrategies: "[selectStrategies] Action",
  selectStrategiesLoading: "[selectStrategiesLoading] Action",
  selectStrategiesAsync: "[selectStrategiesAsync] Action",
};

const initialState = {
  data: [],
  size: 100,
  total: 10000,
  loading: false,
};

export const select_strategies_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectStrategies:
      return {
        ...state,
        data: payload.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0,
      };
    case actionTypes.selectStrategiesLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  let config = {
    url: "select_request",
  };

  let data = {
    table: "monitoring",
    method_type: "select_strategies",
    data: payload.data ? payload.data : {},
    from: payload.from ? (payload.from - 1) * payload.size : 0,
    size: payload.size,
    sort_by: payload.sort_by,
  };

  yield put({
    type: actionTypes.selectStrategiesLoading,
    payload: true,
  });

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);

    if (!isOk) return;
    yield put({
      type: actionTypes.selectStrategies,
      payload: res.data.response.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectStrategiesLoading,
      payload: false,
    });
  }
}

export function* selectStrategies() {
  yield takeLatest(actionTypes.selectStrategiesAsync, handleWorker);
}
